import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { formatINR } from "@/data/products";
import { EASE } from "@/components/Reveal";

export const Swatch = ({ finish, active, onClick, testId, size = "h-5 w-5" }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={onClick}
    title={finish.name}
    aria-label={finish.name}
    className={`rounded-full p-[3px] ring-1 transition-[box-shadow] duration-300 ${active ? "ring-ink" : "ring-transparent hover:ring-ink/30"}`}
  >
    <span className={`block ${size} rounded-full`} style={{ background: `linear-gradient(135deg, ${finish.swatch[0]} 50%, ${finish.swatch[1]} 50%)` }} />
  </button>
);

export const ProductCard = ({ product, index }) => {
  const [finish, setFinish] = useState(0);
  return (
    <motion.article
      layout
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.96 }}
      transition={{ duration: 0.7, ease: EASE, delay: (index % 3) * 0.08 }}
      className="group"
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/product/${product.slug}`} data-testid={`product-card-link-${product.slug}`} className="relative block aspect-[4/5] overflow-hidden rounded-sm bg-sand">
        {product.finishes.map((f, i) => (
          <img
            key={f.id}
            src={f.image}
            alt={`${product.name} ${product.type} in ${f.name}`}
            loading="lazy"
            className={`absolute inset-0 h-full w-full object-cover transition-[opacity,transform] duration-[1200ms] ease-out group-hover:scale-[1.05] ${
              i === finish ? "opacity-100" : "opacity-0"
            }`}
          />
        ))}
        <span className="absolute left-4 top-4 font-display text-lg text-white mix-blend-difference">{String(index + 1).padStart(2, "0")}</span>
        <span className="absolute bottom-4 right-4 translate-y-3 rounded-full bg-bone px-4 py-2 text-[11px] uppercase tracking-[0.16em] opacity-0 transition-[opacity,transform] duration-500 group-hover:translate-y-0 group-hover:opacity-100">
          View piece
        </span>
      </Link>
      <div className="mt-5 flex items-start justify-between gap-4">
        <div>
          <p className="text-[11px] uppercase tracking-[0.2em] text-muted">{product.type}</p>
          <h3 className="mt-1 font-display text-3xl leading-none">{product.name}</h3>
        </div>
        <p className="pt-4 text-sm tabular-nums" data-testid={`product-price-${product.slug}`}>{formatINR(product.price)}</p>
      </div>
      <div className="mt-3 flex items-center gap-1.5">
        {product.finishes.map((f, i) => (
          <Swatch key={f.id} finish={f} active={i === finish} onClick={() => setFinish(i)} testId={`card-swatch-${product.slug}-${f.id}`} />
        ))}
        <span className="ml-2 text-xs text-muted">{product.finishes[finish].name}</span>
      </div>
    </motion.article>
  );
};
